import React, { useState, useEffect } from 'react'
import './ProductoDetalleFormato.scss'
import { DobleGuion } from './DobleGuion'
import { UMVIcon } from '../utils/icons'
import { PackIcon } from '../utils/icons'
import { PalletIcon } from '../utils/icons'
import { SetIcon } from '../utils/icons'
import { setFormatSelected } from '../actions/index'
import { connect } from 'react-redux'
import { firstCharCapitalize } from '../utils/utils'

 const ProductoDetalleFormato = (props) => {
    const { producto } = props

    useEffect(() => {
        if (producto.UVenta2021Suelto !== '' && producto.UVenta2021Suelto !== '-') {
            props.setFormatSelected('UVenta2021Suelto')
        } else {
            props.setFormatSelected('UnidadesPack')
        }
    }, [props.producto])

    const handleClickSelectFormat = (format) => {
        props.setFormatSelected(format)
    }

    return (
        <div className="producto-detalle-formato">
            <div className="titulo"><p>Elige formato</p> <DobleGuion /></div>

            {producto.UVenta2021Suelto !== '' && producto.UVenta2021Suelto !== '-' && producto.Descripcion.toLowerCase().indexOf('set/') === -1 &&
                <div className={`btn ${props.formatSelected == 'UVenta2021Suelto' ? 'btn-selected' : ''}`} onClick={() => handleClickSelectFormat('UVenta2021Suelto')}>
                    <div className="icono"><UMVIcon size={18} /></div>
                    <div className="texto"><p>{firstCharCapitalize('Unidad mín. de venta')}</p></div>
                </div>
            }
            {producto.UVenta2021Suelto !== '' && producto.UVenta2021Suelto !== '-' && producto.Descripcion.toLowerCase().indexOf('set/') > -1 &&
                <div className={`btn ${props.formatSelected == 'UVenta2021Suelto' ? 'btn-selected' : ''}`} onClick={() => handleClickSelectFormat('UVenta2021Suelto')}>
                    <div className="icono"><SetIcon size={18} /></div>
                    <div className="texto"><p>{firstCharCapitalize('Set')}</p></div>
                </div>
            }
            {producto.UnidadesPack !== '' && producto.UnidadesPack !== '-' &&
                <div className={`btn ${props.formatSelected == 'UnidadesPack' ? 'btn-selected' : ''}`} onClick={() => handleClickSelectFormat('UnidadesPack')}>
                    <div className="icono"><PackIcon size={18} /></div>
                    <div className="texto"><p>{firstCharCapitalize('Pack')}</p></div>
                </div>
            }
            {producto.UnidadesPallet !== '' && producto.UnidadesPallet !== '-' &&
                <React.Fragment>
                    <div className={`btn ${props.formatSelected == 'UnidadesPallet' ? 'btn-selected' : ''}`} onClick={() => handleClickSelectFormat('UnidadesPallet')}>
                        <div className="icono"><PalletIcon size={18} /></div>
                        <div className="texto"><p>{firstCharCapitalize('Pallet')}</p></div>
                    </div>
                    <div className="descuento"><p>*Descuento comprando Palet</p></div>
                </React.Fragment>

            }
        </div>
    )
}

const mapDispatchToProps = {
    setFormatSelected
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleFormato)